import axios from "axios";
import { toast } from "react-toastify";

import {
  DownloadExperienceRequestPathParamType,
  DownloadExperienceRequestQueryParamType,
  DownloadExperienceResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const downloadExperience = async (
  payload: ApiRequest<
    any,
    DownloadExperienceRequestPathParamType,
    DownloadExperienceRequestQueryParamType
  >
) => {
  const resp = await api.get<DownloadExperienceResponseBodyType>(
    `/v2/experience/${payload.pathParams.experienceId}/download`,
    {
      params: {
        datasetId: payload.queryParams.datasetId,
        sendTo: payload.queryParams.sendTo,
      },
    }
  );
  return resp.data;
};
export const useDownloadExperience = () => {
  return useMutation<
    DownloadExperienceResponseBodyType,
    Error,
    ApiRequest<
      any,
      DownloadExperienceRequestPathParamType,
      DownloadExperienceRequestQueryParamType
    >
  >({
    mutationFn: async (data) => downloadExperience(data),
    onError: (error) => {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 503) {
          // Do nothing
        } else {
          toast.error(`Something went wrong... ${error.message}`);
        }
      }
    },
  });
};
